import React from "react";
import styles from "../styles/ServicePageStyle.module.css";
import { Container, Row, Button } from "react-bootstrap";
import whychooseus from "./../assets/imgs/whychooseus.jpg";
import { FaCheckCircle } from "react-icons/fa";
import { FaBox } from "react-icons/fa";
import Ship from "./../assets/icons/Ship.svg";
import Order from "./../assets/icons/Order.svg";
import Waybill from "./../assets/icons/Waybill.svg";
import ArrowForwardCirlce from "./../assets/imgs/arrow_forward_circle.png";
import "./service-page.css";

const ServicePage = () => {
  return (
    <div>
      <section className={styles.content}>
        <div className={styles.backdrop}></div>
      </section>
      <section>
        <Container fluid>
          <Row className={styles.office_details}>
            <div className="col-10">
              <h4>Welcome to EasyF International Logistics</h4>
              <p>
                EasyFreight Logistics brings you flexible, reliable ocean
                freight forwarding solutions built around operational
                excellence. We take the time to understand your business and
                then work with you to develop customized transportation
                solutions,from finding the best schedule for shipments to
                securing competitive rates. Whether you need to split or share
                loads or link with other services – such as air freight
                forwarding, multimodal transport, cross-border services, or
                customs house brokerage services – we always go above and beyond
                to help you find the solutions you need.
              </p>
              <h5>
                We are a specialized cargo freight forwarding company, being
                your 'architect' of freight transportation by sea and land. Our
                services include:
              </h5>
              <ul>
                <li>
                  Freight Forwarding solutions: Ocean Freight and Land Freight
                </li>
                <li> General freight forwarding</li>
                <li>
                  Project freight forwarding (One stop service for trading
                  company)
                </li>
                <li> Full container load (FCL)</li>
                <li> Less than Container Load (LCL)</li>
                <li>International/intercontinental cargo shipping solutions</li>
                <li> Delivery services by truck</li>
                <li> Multimodal solutions</li>
                <li> Heavy lift cargo handling</li>
                <li> Customs clearance documentation</li>
                <li> Insurance</li>
                <li> Storage</li>
              </ul>
              <h5>Your go-to freight forwarder</h5>
              <p>
                Your go-to freight forwarder EasyF is your go-to freight
                forwarder when you are looking for a competitive pricing service
                that takes the entire freight shipping process off your hands,
                whether it is shipping cargo by air, ocean, or land. We arrange
                your logistics process from A to Z.
              </p>
            </div>
          </Row>
        </Container>
      </section>
      {/* <section className={`${styles.content} ${styles.second_banner_image}`}>
        <div className={styles.bannerDrop}>
          <h3>Service Network</h3>
          <div>
            <div className={styles.bannerDropInfo}>
              <img src={ArrowForwardCirlce} />
              <p>North Asia - ASEAN</p>
            </div>
            <div className={styles.bannerDropInfo}>
              <img src={ArrowForwardCirlce} />
              <p>Infra Asia - ASEAN</p>
            </div>
            <div className={styles.bannerDropInfo}>
              <img src={ArrowForwardCirlce} />
              <p>Asia - India Subcontinent</p>
            </div>
            <div className={styles.bannerDropInfo}>
              <img src={ArrowForwardCirlce} />
              <p>Asia - Gulf</p>
            </div>
            <div className={styles.bannerDropInfo}>
              <img src={ArrowForwardCirlce} />
              <p>Feeder</p>
            </div>
          </div>
        </div>
      </section> */}
      <section>
        <Container fluid>
          <Row>
            <div className="col-lg-6 col-md-12 d-flex justify-content-center align-items-center">
              <img src={whychooseus} style={{ width: "90%", height: "80%" }} />
            </div>
            <div className="col-lg-6 col-md-12 d-flex flex-column justify-content-center align-items-center ">
              <div className="why-choose-us-header">
                <h3 className="fw-bold">Why Choose EasyFreight?</h3>
              </div>
              <div className="d-flex">
                <div className="check-icon">
                  <FaCheckCircle />
                </div>
                <div className="why-choose-us-content">
                  <h5>Fast Shipping</h5>
                  <p>
                    Fast Shipping from China to Myanmar, by sea or truck? We
                    offer fast, reliable and accurate worldwide delivery
                    directly to your doors , factory and warehouse.
                  </p>
                </div>
              </div>
              <div className="d-flex">
                <div className="check-icon">
                  <FaCheckCircle />
                </div>

                <div className="why-choose-us-content">
                  <h5>End-to-end solution available</h5>
                  <p>
                    We are now offering end-to-end solution using multiple
                    transportation means and covering all supply chain from the
                    origin to the destination.
                  </p>
                </div>
              </div>
              <div className="d-flex">
                <div className="check-icon">
                  <FaCheckCircle />
                </div>
                <div className="why-choose-us-content">
                  <h5>Safety & Compliance</h5>
                  <p>
                    Safety of your cargo is our top priorties. Every package is
                    handled with most care by our trained and high skilled
                    personnel. You can be sure that your cargo will travel and
                    arrive safely.
                  </p>
                </div>
              </div>
            </div>
          </Row>
        </Container>
      </section>
      <section className={"solution-section"}>
        <div className="header">
          <FaBox className="box-icon" />
          <p>
            Logistic Solution are often thought to be costly but they don't have
            to be
          </p>
        </div>
        <div className="info-container">
          <div className="info">
            <img src={Ship} />
            <div>
              <h6>Exceptional services</h6>
              <p>
                {" "}
                Having been in the industry for nearly three decades, well
                equipped with the network and resources to ensure your cargo
                reaches its destination safely and on time.
              </p>
            </div>
          </div>
          <div className="info">
            <img src={Order} />
            <div>
              <h6>Flexible Pricing</h6>
              <p>
                {" "}
                From collecting the cargo to delivering it. our flexible fees
                suit our clients' needs.
              </p>
            </div>
          </div>
          <div className="info">
            <img src={Waybill} />
            <div>
              <h6>Premium Support</h6>
              <p>
                {" "}
                We take conventional cargo shipping to the next level by
                offering our clients complete support--from customs
                documentation to clearance, commercial invoicing, and export
                licenses--we assist our clients througout the process
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className={"next-step-section"}>
        <div className="header">
          <h6>Ready to take the next step? Get in touch</h6>
        </div>
        <p>
          You don't have to worry about a thing. Your shipment is taken care of
          by the most dedicated and qualified people. Ready to sit back and
          relax? You can rely on our tailored solutions to be certain your goods
          will arrive at their destination on time. Let us help you take the
          steps needed to ship your cargo the best way possible
        </p>
        <Button
          onClick={() => {
            window.location = "/contact-us";
          }}
        >
          Contact Us Now
        </Button>
      </section>
    </div>
  );
};
export default ServicePage;
